import { MapMarkerAlertIcon } from './MapMarkerAlertIcon';

/**
 * author: François Risoud
 * id DE87F14C-101D-47F2-87C5-118BE76F7C58
 * name map-marker-alert
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-alert.svg
 * tags
 * - Navigation 
 * - Alert / Error 
 * - Geographic Information System 
 */
export const LocationAlertIcon = MapMarkerAlertIcon;
export default LocationAlertIcon